import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CompanyInfoTable from '../../../components/tables/CompanyInfoTable';
import Card from '../../../components/common/Card';
import { CompanyInfoClient, CompanyInfoDTO } from '../../../services/apiClient';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../../config/config';
import axiosInstance from "../../../services/axiosInstance";

const CompanyInfoList: React.FC = () => {
  const [data, setData] = useState<CompanyInfoDTO[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const apiClient = new CompanyInfoClient(API_BASE_URL, axiosInstance);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Company Info', href: '/admin/companyinfo' },
  ];

  const fetchCompanyInfos = async (page: number, size: number) => {
    try {
      setIsLoading(true);
      const response = await apiClient.searchCompanyInfos({
        page,
        pageSize: size,
        sortBy: 'Name',
        sortDescending: false,
        filters: {},
      });
      setData(response.data?.results as CompanyInfoDTO[] || []);
      setTotalRecords(response.data?.totalCount || 0);
      setTotalPages(Math.ceil((response.data?.totalCount || 0) / size));
    } catch (error) {
      console.error('Error fetching company info:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanyInfos(currentPage, pageSize);
  }, [currentPage, pageSize]);

  return (
    <AdminLayout
      title="Company Info"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Administrator']}
    >
      <Card>
        <div className="flex justify-between mb-4">
          <h2 className="text-lg font-bold text-gray-500">
            Manage Company Info ({totalRecords})
          </h2>
        </div>
        <CompanyInfoTable
          services={data}
          handleEdit={(dto) =>
            navigate(`/admin/companyinfo/${dto.id}`)
          }
          currentPage={currentPage}
          totalPages={totalPages}
          setCurrentPage={setCurrentPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          isLoading={isLoading}
        />
      </Card>
    </AdminLayout>
  );
};

export default CompanyInfoList;
